import Close from "@mui/icons-material/Close";
import { Box, IconButton, Link, Typography } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthProvider";
import { localStorageService } from "@/services/LocalStorageService";
import { trackEvent } from "@/utils/analytics";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/utils/models";

export const MobilePromotionBanner: FC = () => {
	const { t } = useTranslation();
	const {
		userInfo: { id: userId },
	} = useAuth();
	const [hideBanner, setHideBanner] = useState<boolean>(localStorageService.getMobilePromotionBannerHide(userId));

	useEffect(() => {
		if (hideBanner) localStorageService.setMobilePromotionBannerHide(hideBanner, userId);
	}, [hideBanner]);

	if (hideBanner) return null;

	return (
		<Box
			sx={{
				position: "fixed",
				left: 12,
				right: 12,
				bottom: 12,
				maxWidth: 500,
				margin: "0 auto",
				padding: 1.25,
				backgroundColor: "primary.light",
				borderRadius: 2,
				boxShadow: 4,
				display: "flex",
				flexDirection: "row",
				gap: 1,
				justifyContent: "space-between",
				alignItems: "center",
				zIndex: (theme) => theme.zIndex.snackbar,
			}}
		>
			<Box sx={{ minWidth: 0, pr: 0.5 }}>
				<Typography component="h2" sx={{ fontSize: "16px", fontWeight: 700, color: "common.white", margin: 0, padding: 0, lineHeight: 1.2 }}>
					{t("mobile.promotion.title")}
				</Typography>
				<Typography component="p" sx={{ fontSize: "13px", fontWeight: 600, color: "common.white", opacity: 0.9, margin: 0, padding: 0, lineHeight: 1.25 }}>
					{t("mobile.promotion.description")}
				</Typography>
			</Box>
			<Box sx={{ display: "flex", gap: 0.75, flexShrink: 0 }}>
				<Link href={PLAY_STORE_URL} onClick={() => trackEvent("mobile_promotion_banner_clicked", { store: "google" })}>
					<img src="/google-play-store.png" className="ml-auto" alt="Google play store" width={96} height={32} />
				</Link>
				<Link href={APP_STORE_URL} onClick={() => trackEvent("mobile_promotion_banner_clicked", { store: "apple" })}>
					<img src="/apple-app-store.png" className="mr-auto" alt="Apple app store" width={96} height={32} />
				</Link>
			</Box>
			<IconButton
				aria-label={t("close")}
				onClick={() => {
					trackEvent("mobile_promotion_banner_hide_clicked");
					setHideBanner(true);
				}}
				sx={{ position: "absolute", top: -12, right: -8, bgcolor: "background.paper", boxShadow: 2, "&:hover": { bgcolor: "background.paper" } }}
			>
				<Close fontSize="small" />
			</IconButton>
		</Box>
	);
};
